<div
  class="body ui container fluid"
  fxLayout="column"
  fxLayoutAlign="flex-start none"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <label class="ui grey">Home / Settings</label>
        <h2 class="ui primary header">Application Security</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px"></div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div class="security-cards">
    <div routerLink="dashboard">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.375 36.75C41.4529 36.75 40.5824 36.9745 39.8137 37.3696L35.6199 33.1758C37.6179 30.6508 38.8125 27.4625 38.8125 24C38.8125 20.5906 37.6542 17.447 35.7107 14.9407L39.9514 10.7003C40.6857 11.0522 41.5078 11.25 42.375 11.25C43.4106 11.25 44.25 10.4106 44.25 9.375C44.25 8.33936 43.4106 7.5 42.375 7.5C41.3412 7.5 40.5 6.65881 40.5 5.625C40.5 4.59119 41.3412 3.75 42.375 3.75C43.4088 3.75 44.25 4.59119 44.25 5.625C44.25 6.66064 45.0894 7.5 46.125 7.5C47.1606 7.5 48 6.66064 48 5.625C48 2.52319 45.4768 0 42.375 0C39.2732 0 36.75 2.52319 36.75 5.625C36.75 6.49219 36.9478 7.31433 37.2997 8.04858L33.0593 12.2893C30.553 10.3462 27.4094 9.1875 24 9.1875C20.5375 9.1875 17.3489 10.3821 14.8242 12.3801L10.6304 8.18628C11.0255 7.4176 11.25 6.54749 11.25 5.625C11.25 2.52319 8.72681 0 5.625 0C2.52319 0 0 2.52319 0 5.625C0 8.72681 2.52319 11.25 5.625 11.25C6.43652 11.25 7.20813 11.0757 7.90576 10.7651L12.1989 15.0582C10.3103 17.5452 9.1875 20.6437 9.1875 24C9.1875 27.4094 10.3458 30.553 12.2893 33.059L8.04858 37.2997C7.31433 36.9478 6.49219 36.75 5.625 36.75C2.52319 36.75 0 39.2732 0 42.375C0 45.4768 2.52319 48 5.625 48C6.66064 48 7.5 47.1606 7.5 46.125C7.5 45.0894 6.66064 44.25 5.625 44.25C4.59119 44.25 3.75 43.4088 3.75 42.375C3.75 41.3412 4.59119 40.5 5.625 40.5C6.65881 40.5 7.5 41.3412 7.5 42.375C7.5 43.4106 8.33936 44.25 9.375 44.25C10.4106 44.25 11.25 43.4106 11.25 42.375C11.25 41.5078 11.0522 40.6857 10.7003 39.9514L14.941 35.7107C17.447 37.6538 20.5906 38.8125 24 38.8125C27.3563 38.8125 30.4552 37.6897 32.9418 35.8011L37.2349 40.0942C36.9243 40.7919 36.75 41.5635 36.75 42.375C36.75 45.4768 39.2732 48 42.375 48C43.4106 48 44.25 47.1606 44.25 46.125C44.25 45.0894 43.4106 44.25 42.375 44.25C41.3412 44.25 40.5 43.4088 40.5 42.375C40.5 41.3412 41.3412 40.5 42.375 40.5C43.4088 40.5 44.25 41.3412 44.25 42.375C44.25 43.4106 45.0894 44.25 46.125 44.25C47.1606 44.25 48 43.4106 48 42.375C48 39.2732 45.4768 36.75 42.375 36.75ZM35.0625 24C35.0625 26.6345 34.1364 29.0566 32.5931 30.9584C31.8453 29.1141 30.5208 27.5632 28.8435 26.5309C29.684 25.4744 30.1875 24.1392 30.1875 22.6875C30.1875 19.2755 27.412 16.5 24 16.5C20.588 16.5 17.8125 19.2755 17.8125 22.6875C17.8125 24.1392 18.316 25.4744 19.1565 26.5309C17.4792 27.5632 16.1547 29.1141 15.4069 30.9584C13.8636 29.0566 12.9375 26.6345 12.9375 24C12.9375 17.9 17.9 12.9375 24 12.9375C30.1 12.9375 35.0625 17.9 35.0625 24ZM24 25.125C22.656 25.125 21.5625 24.0315 21.5625 22.6875C21.5625 21.3435 22.656 20.25 24 20.25C25.344 20.25 26.4375 21.3435 26.4375 22.6875C26.4375 24.0315 25.344 25.125 24 25.125ZM3.75 5.625C3.75 4.59119 4.59119 3.75 5.625 3.75C6.65881 3.75 7.5 4.59119 7.5 5.625C7.5 6.65881 6.65881 7.5 5.625 7.5C4.59119 7.5 3.75 6.65881 3.75 5.625ZM18.542 33.6193C18.9349 30.9595 21.2325 28.9113 24 28.9113C26.7675 28.9113 29.0651 30.9595 29.458 33.6193C27.8463 34.5374 25.9834 35.0625 24 35.0625C22.0166 35.0625 20.1537 34.5374 18.542 33.6193Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div class="text-center">Dashboard</div>
    </div>

    <div routerLink="user-management">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32 14C32 18.4183 28.4183 22 24 22C19.5817 22 16 18.4183 16 14C16 9.58172 19.5817 6 24 6C28.4183 6 32 9.58172 32 14Z"
            stroke="#3F4395"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24 28C16.268 28 10 34.268 10 42H38C38 34.268 31.732 28 24 28Z"
            stroke="#3F4395"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="text-center">Users</div>
    </div>

    <div routerLink="alerts">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6863_40941)">
            <path
              d="M26.5983 6.29688L43.8663 36.2049C44.1297 36.6609 44.2683 37.1782 44.2683 37.7049C44.2683 38.2315 44.1297 38.7488 43.8664 39.2048C43.6031 39.6609 43.2244 40.0396 42.7683 40.3029C42.3123 40.5662 41.795 40.7049 41.2683 40.7049H6.73235C6.20574 40.7049 5.68842 40.5662 5.23237 40.3029C4.77633 40.0396 4.39762 39.6609 4.13433 39.2048C3.87103 38.7488 3.73242 38.2315 3.73242 37.7049C3.73243 37.1782 3.87104 36.6609 4.13435 36.2049L21.4023 6.29688C22.5563 4.29688 25.4423 4.29688 26.5983 6.29688ZM24.0003 9.79687L8.46435 36.7049H39.5363L24.0003 9.79687ZM24.0003 30.0009C24.5308 30.0009 25.0395 30.2116 25.4146 30.5867C25.7896 30.9617 26.0003 31.4704 26.0003 32.0009C26.0003 32.5313 25.7896 33.04 25.4146 33.4151C25.0395 33.7902 24.5308 34.0009 24.0003 34.0009C23.4699 34.0009 22.9612 33.7902 22.5861 33.4151C22.2111 33.04 22.0003 32.5313 22.0003 32.0009C22.0003 31.4704 22.2111 30.9617 22.5861 30.5867C22.9612 30.2116 23.4699 30.0009 24.0003 30.0009ZM24.0003 16.0009C24.5308 16.0009 25.0395 16.2116 25.4146 16.5867C25.7896 16.9617 26.0003 17.4704 26.0003 18.0009V26.0009C26.0003 26.5313 25.7896 27.04 25.4146 27.4151C25.0395 27.7902 24.5308 28.0009 24.0003 28.0009C23.4699 28.0009 22.9612 27.7902 22.5861 27.4151C22.2111 27.04 22.0003 26.5313 22.0003 26.0009V18.0009C22.0003 17.4704 22.2111 16.9617 22.5861 16.5867C22.9612 16.2116 23.4699 16.0009 24.0003 16.0009Z"
              fill="#3F4395"
            />
          </g>
          <defs>
            <clipPath id="clip0_6863_40941">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="text-center">Alerts</div>
    </div>

    <div routerLink="logs">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 2H46V46H2V2ZM6 19.334V42H42V19.334H6ZM42 15.334V6H6V15.334H42ZM10 8H14.008V12.008H10V8ZM12 24H36V28H12V24ZM12 32H24V36H12V32Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div class="text-center">Logs</div>
    </div>

    <div routerLink="geofence-management">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.1066 32.212C35.5447 31.9929 36.0478 31.9421 36.5208 32.0693C36.9938 32.1965 37.4036 32.4928 37.6726 32.902L37.7886 33.106L41.7886 41.106C41.9314 41.3913 42.0038 41.7066 41.9998 42.0256C41.9959 42.3445 41.9157 42.6579 41.7659 42.9396C41.6162 43.2213 41.4012 43.4631 41.139 43.6447C40.8768 43.8264 40.575 43.9427 40.2586 43.984L40.0006 44H8.00064C7.68158 44.0001 7.36713 43.9239 7.08354 43.7777C6.79995 43.6315 6.55545 43.4195 6.37046 43.1596C6.18548 42.8996 6.06537 42.5992 6.02017 42.2833C5.97497 41.9675 6.00599 41.6454 6.11064 41.344L6.21064 41.104L10.2106 33.104C10.4348 32.6406 10.8291 32.2815 11.3114 32.1014C11.7936 31.9213 12.3268 31.9341 12.7998 32.1371C13.2729 32.3402 13.6494 32.7178 13.8511 33.1914C14.0528 33.6651 14.0641 34.1982 13.8826 34.68L13.7886 34.894L11.2366 40H36.7646L34.2126 34.894C33.9758 34.4198 33.9369 33.8709 34.1046 33.368C34.2722 32.8651 34.6326 32.4493 35.1066 32.212ZM24.0006 4C27.7137 4 31.2746 5.475 33.9001 8.1005C36.5256 10.726 38.0006 14.287 38.0006 18C38.0006 22.764 35.4226 26.634 32.7546 29.38C31.2808 30.8769 29.6608 32.2222 27.9186 33.396L27.1726 33.888L26.5086 34.306C26.4046 34.368 26.3046 34.426 26.2106 34.486L25.6966 34.782C24.6406 35.382 23.3606 35.382 22.3046 34.782L21.7906 34.484L21.1706 34.106C21.0562 34.034 20.9422 33.9613 20.8286 33.888L20.0826 33.396C18.3405 32.2222 16.7204 30.8769 15.2466 29.38C12.5786 26.634 10.0006 22.764 10.0006 18C10.0006 14.287 11.4756 10.726 14.1011 8.1005C16.7267 5.475 20.2876 4 24.0006 4ZM24.0006 8C21.3485 8 18.8049 9.05357 16.9296 10.9289C15.0542 12.8043 14.0006 15.3478 14.0006 18C14.0006 21.272 15.7806 24.19 18.1146 26.592C19.5177 28.011 21.0693 29.2749 22.7426 30.362L23.4226 30.796C23.6326 30.926 23.8266 31.042 24.0006 31.144L24.5806 30.796L25.2586 30.362C26.932 29.2749 28.4836 28.011 29.8866 26.592C32.2206 24.192 34.0006 21.272 34.0006 18C34.0006 15.3478 32.9471 12.8043 31.0717 10.9289C29.1963 9.05357 26.6528 8 24.0006 8ZM24.0006 12C25.5919 12 27.1181 12.6321 28.2433 13.7574C29.3685 14.8826 30.0006 16.4087 30.0006 18C30.0006 19.5913 29.3685 21.1174 28.2433 22.2426C27.1181 23.3679 25.5919 24 24.0006 24C22.4093 24 20.8832 23.3679 19.758 22.2426C18.6328 21.1174 18.0006 19.5913 18.0006 18C18.0006 16.4087 18.6328 14.8826 19.758 13.7574C20.8832 12.6321 22.4093 12 24.0006 12ZM24.0006 16C23.4702 16 22.9615 16.2107 22.5864 16.5858C22.2114 16.9609 22.0006 17.4696 22.0006 18C22.0006 18.5304 22.2114 19.0391 22.5864 19.4142C22.9615 19.7893 23.4702 20 24.0006 20C24.5311 20 25.0398 19.7893 25.4149 19.4142C25.7899 19.0391 26.0006 18.5304 26.0006 18C26.0006 17.4696 25.7899 16.9609 25.4149 16.5858C25.0398 16.2107 24.5311 16 24.0006 16Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div class="text-center">Geo Fencing</div>
    </div>

    <div routerLink="ip-management">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6863_40754)">
            <path
              d="M24 16.5C25.6569 16.5 27 15.1569 27 13.5C27 11.8431 25.6569 10.5 24 10.5C22.3431 10.5 21 11.8431 21 13.5C21 15.1569 22.3431 16.5 24 16.5Z"
              fill="#3F4395"
            />
            <path
              d="M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z"
              fill="#3F4395"
            />
            <path
              d="M28.224 39.0006C28.0003 38.3731 27.6398 37.8031 27.1687 37.332C26.6976 36.8608 26.1276 36.5004 25.5 36.2766V33.0006H30C30.2199 33.0005 30.437 32.9521 30.6361 32.8588C30.8352 32.7655 31.0113 32.6296 31.152 32.4606L38.652 23.4606C38.7988 23.2845 38.9033 23.077 38.9574 22.8541C39.0114 22.6313 39.0137 22.399 38.964 22.1751L35.964 8.67513C35.9126 8.44288 35.8066 8.22622 35.6548 8.04309C35.503 7.85997 35.3097 7.71567 35.091 7.62213L24.591 3.12213C24.4044 3.04156 24.2033 3 24 3C23.7967 3 23.5956 3.04156 23.409 3.12213L12.9075 7.62213C12.6886 7.71558 12.4951 7.85983 12.343 8.04295C12.1909 8.22606 12.0847 8.44277 12.033 8.67513L9.036 22.1751C8.98628 22.399 8.98855 22.6313 9.04264 22.8541C9.09673 23.077 9.20119 23.2845 9.348 23.4606L16.848 32.4606C16.9887 32.6296 17.1648 32.7655 17.3639 32.8588C17.563 32.9521 17.7801 33.0005 18 33.0006H22.5V36.2781C21.8725 36.5015 21.3025 36.8617 20.8314 37.3326C20.3602 37.8034 19.9997 38.3732 19.776 39.0006H6V42.0006H19.776C20.397 43.7421 22.047 45.0006 24 45.0006C25.953 45.0006 27.603 43.7421 28.224 42.0006H42V39.0006H28.224ZM12.1245 22.1061L14.7945 10.0761L24 6.13113L33.2025 10.0761L35.8755 22.1061L29.298 30.0006H18.702L12.1245 22.1061ZM24 42.0006C23.6138 41.9834 23.2491 41.8178 22.9819 41.5384C22.7147 41.2589 22.5656 40.8872 22.5656 40.5006C22.5656 40.114 22.7147 39.7423 22.9819 39.4629C23.2491 39.1835 23.6138 39.0179 24 39.0006C24.3862 39.0179 24.7509 39.1835 25.0181 39.4629C25.2853 39.7423 25.4344 40.114 25.4344 40.5006C25.4344 40.8872 25.2853 41.2589 25.0181 41.5384C24.7509 41.8178 24.3862 41.9834 24 42.0006Z"
              fill="#3F4395"
            />
          </g>
          <defs>
            <clipPath id="clip0_6863_40754">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="text-center">IP Management</div>
    </div>

    <div routerLink="file-upload">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.5 10C8.5 8.54131 9.07946 7.14236 10.1109 6.11091C11.1424 5.07946 12.5413 4.5 14 4.5H29.974C30.5299 4.5 31.0779 4.63243 31.5724 4.88632C32.067 5.14021 32.494 5.50827 32.818 5.96L38.844 14.354C39.27 14.95 39.5 15.664 39.5 16.394V38C39.5 39.4587 38.9205 40.8576 37.8891 41.8891C36.8576 42.9205 35.4587 43.5 34 43.5H14C12.5413 43.5 11.1424 42.9205 10.1109 41.8891C9.07946 40.8576 8.5 39.4587 8.5 38V10ZM14 7.5C12.62 7.5 11.5 8.62 11.5 10V38C11.5 39.38 12.62 40.5 14 40.5H34C35.38 40.5 36.5 39.38 36.5 38V17.794H30C29.6022 17.794 29.2206 17.636 28.9393 17.3547C28.658 17.0734 28.5 16.6918 28.5 16.294V7.5H14Z"
            fill="#3F4395"
          />
          <path
            d="M30.1715 26.438C30.0484 26.592 29.8962 26.7203 29.7235 26.8154C29.5508 26.9106 29.361 26.9707 29.165 26.9925C28.9691 27.0142 28.7707 26.9971 28.5814 26.9421C28.392 26.8871 28.2154 26.7953 28.0615 26.672L25.5015 24.62V31.5C25.5015 31.8978 25.3435 32.2794 25.0622 32.5607C24.7809 32.842 24.3993 33 24.0015 33C23.6037 33 23.2222 32.842 22.9409 32.5607C22.6596 32.2794 22.5015 31.8978 22.5015 31.5V24.62L19.9375 26.672C19.6267 26.9205 19.2299 27.0354 18.8344 26.9913C18.4388 26.9472 18.077 26.7478 17.8285 26.437C17.58 26.1262 17.4652 25.7293 17.5092 25.3338C17.5533 24.9383 17.7527 24.5765 18.0635 24.328L23.0575 20.332C23.3209 20.1191 23.6489 20.0021 23.9875 20H24.0035C24.3635 20 24.6915 20.128 24.9495 20.34L29.9375 24.328C30.0916 24.4511 30.2198 24.6033 30.315 24.776C30.4101 24.9487 30.4703 25.1385 30.492 25.3345C30.5137 25.5305 30.4966 25.7288 30.4416 25.9181C30.3866 26.1075 30.2948 26.2842 30.1715 26.438Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div class="text-center">File Upload</div>
    </div>

    <div routerLink="rate-limit">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 28L17.594 23.688C19.018 21.978 19.73 21.124 20.666 21.124C21.604 21.124 22.316 21.978 23.74 23.688L24.26 24.312C25.684 26.022 26.396 26.876 27.334 26.876C28.27 26.876 28.982 26.022 30.406 24.312L34 20"
            stroke="#3F4395"
            stroke-width="3"
            stroke-linecap="round"
          />
          <path
            d="M44 24C44 33.428 44 38.142 41.07 41.07C38.144 44 33.428 44 24 44C14.572 44 9.858 44 6.928 41.07C4 38.144 4 33.428 4 24C4 14.572 4 9.858 6.928 6.928C9.86 4 14.572 4 24 4C33.428 4 38.142 4 41.07 6.928C43.018 8.876 43.67 11.614 43.89 16"
            stroke="#3F4395"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="text-center">Rate Limit</div>
    </div>

    <div routerLink="dynamic-header">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 7.5V10.5H10.5V37.5H9V40.5H21V37.5H19.5V28.5H28.5V37.5H27V40.5H39V37.5H37.5V10.5H39V7.5H27V10.5H28.5V19.5H19.5V10.5H21V7.5H9ZM13.5 10.5H16.5V22.5H31.5V10.5H34.5V37.5H31.5V25.5H16.5V37.5H13.5V10.5Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div class="text-center">Dynamic Header</div>
    </div>

    <div routerLink="settings">
      <div fxLayout="row" class="card">
        <svg
          style="margin: auto"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 30C27.3137 30 30 27.3137 30 24C30 20.6863 27.3137 18 24 18C20.6863 18 18 20.6863 18 24C18 27.3137 20.6863 30 24 30Z"
            stroke="#3F4395"
            stroke-width="3"
          />
          <path
            d="M27.5309 4.304C26.7969 4 25.8649 4 24.0009 4C22.1369 4 21.2049 4 20.4709 4.304C19.9853 4.50503 19.544 4.79979 19.1723 5.17145C18.8007 5.5431 18.5059 5.98436 18.3049 6.47C18.1209 6.916 18.0469 7.438 18.0189 8.196C18.0064 8.74398 17.8549 9.2798 17.5785 9.75314C17.3021 10.2265 16.91 10.6218 16.4389 10.902C15.9607 11.1701 15.4222 11.3122 14.874 11.315C14.3258 11.3178 13.7858 11.1812 13.3049 10.918C12.6329 10.562 12.1469 10.366 11.6649 10.302C10.6135 10.1637 9.5503 10.4486 8.7089 11.094C8.0809 11.58 7.6129 12.386 6.6809 14C5.7489 15.614 5.2809 16.42 5.1789 17.21C5.11017 17.7309 5.14474 18.2602 5.28063 18.7678C5.41653 19.2753 5.65108 19.7511 5.9709 20.168C6.2669 20.552 6.6809 20.874 7.3229 21.278C8.2689 21.872 8.8769 22.884 8.8769 24C8.8769 25.116 8.2689 26.128 7.3229 26.72C6.6809 27.126 6.2649 27.448 5.9709 27.832C5.65108 28.2489 5.41653 28.7247 5.28063 29.2322C5.14474 29.7398 5.11017 30.2691 5.1789 30.79C5.2829 31.578 5.7489 32.386 6.6789 34C7.6129 35.614 8.0789 36.42 8.7089 36.906C9.12577 37.2258 9.60157 37.4604 10.1091 37.5963C10.6167 37.7322 11.146 37.7667 11.6669 37.698C12.1469 37.634 12.6329 37.438 13.3049 37.082C13.7858 36.8188 14.3258 36.6822 14.874 36.685C15.4222 36.6878 15.9607 36.8299 16.4389 37.098C17.4049 37.658 17.9789 38.688 18.0189 39.804C18.0469 40.564 18.1189 41.084 18.3049 41.53C18.5059 42.0156 18.8007 42.4569 19.1723 42.8286C19.544 43.2002 19.9853 43.495 20.4709 43.696C21.2049 44 22.1369 44 24.0009 44C25.8649 44 26.7969 44 27.5309 43.696C28.0165 43.495 28.4578 43.2002 28.8295 42.8286C29.2011 42.4569 29.4959 42.0156 29.6969 41.53C29.8809 41.084 29.9549 40.564 29.9829 39.804C30.0229 38.688 30.5969 37.656 31.5629 37.098C32.0411 36.8299 32.5796 36.6878 33.1278 36.685C33.6761 36.6822 34.216 36.8188 34.6969 37.082C35.3689 37.438 35.8549 37.634 36.3349 37.698C36.8558 37.7667 37.3851 37.7322 37.8927 37.5963C38.4002 37.4604 38.876 37.2258 39.2929 36.906C39.9229 36.422 40.3889 35.614 41.3209 34C42.2529 32.386 42.7209 31.58 42.8229 30.79C42.8916 30.2691 42.8571 29.7398 42.7212 29.2322C42.5853 28.7247 42.3507 28.2489 42.0309 27.832C41.7349 27.448 41.3209 27.126 40.6789 26.722C40.2104 26.4372 39.8219 26.038 39.5501 25.5618C39.2783 25.0857 39.1319 24.5482 39.1249 24C39.1249 22.884 39.7329 21.872 40.6789 21.28C41.3209 20.874 41.7369 20.552 42.0309 20.168C42.3507 19.7511 42.5853 19.2753 42.7212 18.7678C42.8571 18.2602 42.8916 17.7309 42.8229 17.21C42.7189 16.422 42.2529 15.614 41.3229 14C40.3889 12.386 39.9229 11.58 39.2929 11.094C38.876 10.7742 38.4002 10.5396 37.8927 10.4037C37.3851 10.2678 36.8558 10.2333 36.3349 10.302C35.8549 10.366 35.3689 10.562 34.6949 10.918C34.2142 11.1808 33.6747 11.3172 33.1268 11.3144C32.579 11.3116 32.0409 11.1697 31.5629 10.902C31.0918 10.6218 30.6997 10.2265 30.4233 9.75314C30.1469 9.2798 29.9954 8.74398 29.9829 8.196C29.9549 7.436 29.8829 6.916 29.6969 6.47C29.4959 5.98436 29.2011 5.5431 28.8295 5.17145C28.4578 4.79979 28.0165 4.50503 27.5309 4.304Z"
            stroke="#3F4395"
            stroke-width="3"
          />
        </svg>
      </div>
      <div class="text-center">Settings</div>
    </div>
  </div>
</div>
